import { useAuth } from '@/app/hooks/useAuth'
import { onePermission } from '@/app/utils/onePermission'
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@/view/components/TabsTable'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

export const RaffleLayout = () => {
  const { PERMISSIONS, isAdmin } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  if (!onePermission(PERMISSIONS.raffles)) {
    return <Outlet />
  }

  const currentTab = location.pathname.includes('gerenciar')
    ? 'gerenciar'
    : 'sorteios'

  const handleTabChange = (value: string) => {
    if (value === 'gerenciar') {
      navigate('/sorteios/gerenciar')
    } else {
      navigate('/sorteios')
    }
  }

  return (
    <div className="flex min-h-full w-full flex-1 justify-between gap-8">
      <Tabs
        defaultValue={currentTab}
        className="flex-1"
        value={currentTab}
        onValueChange={handleTabChange}
      >
        <div className="flex items-center">
          <TabsList className="flex items-center gap-8">
            <TabsTrigger className="text-xl" value="sorteios">
              Sorteios
            </TabsTrigger>
            {isAdmin && (
              <TabsTrigger className="text-xl" value="gerenciar">
                Gerenciar
              </TabsTrigger>
            )}
          </TabsList>
        </div>

        <TabsContent value="sorteios" className="mt-8 w-full">
          <Outlet />
        </TabsContent>
        <TabsContent value="gerenciar" className="mt-8 w-full">
          <Outlet />
        </TabsContent>
      </Tabs>
    </div>
  )
}
